import { Component, inject } from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-email-sent-dialog',
    templateUrl: './email-sent-dialog.component.html',
    styleUrls: ['./email-sent-dialog.component.scss'],
    imports: [NgIf, TranslatePipe]
})
export class EmailSentDialogComponent {
  activeModal = inject(NgbActiveModal);
}
